import React from 'react';
import classes from './Input.module.scss';

const Input = (props) => {
    // console.log('[Input.js] class');
    let inputElement = null;
    switch (props.inputtype) {
        case('input'):
            inputElement = <input className={props.mute ? classes.Mute : classes.InputElement} {...props}/>
            break;
        case('textarea'):
            inputElement = <textarea className={props.mute ? classes.Mute : classes.InputElement} {...props}/>
            break;
        case('checkbox'):
            inputElement = <input type="checkbox" className={props.mute ? classes.Mute : classes.InputCheckbox} {...props} value={props.value}/>
            break;
        case('select'):
            inputElement = (<select className={classes.InputSelect} {...props}
                                    value={props.selectedvalue}>
                {props.elementconfig.map((option, index) => {
                    return <option key={index}
                                   className={classes.InputElement_option}
                                   value={option.value}>{option.displayValue}</option>
                })}
            </select>)
            break;
        default:
            inputElement = <input className={classes.InputElement} {...props}/>
    }

    // if (props.inputtype !== 'checkbox'){
    //     display = (
    //         <label className={classes.Label}>{props.label}</label> + inputElement
    //     );
    // }

    return (
        <div className={classes.Input}>
            <label className={classes.Label}>{props.label}</label>
            {inputElement}
            {/*{display}*/}
        </div>
    );
}

export default Input;